import type { Option } from '@openx/types/options.ts';

export const handleChildChange = (selectedItems: string[], optionId: string, parentOption?: Option): string[] => {
  const newSelection = [...selectedItems, optionId];
  // If parent exists, check if all siblings selected
  if (parentOption) {
    const siblings = parentOption.children || [];
    const allSiblingsSelected = siblings.every(sibling => newSelection.includes(sibling.id));
    if (allSiblingsSelected) {
      newSelection.push(parentOption.id);
    }
  }
  return [...new Set(newSelection)];
};

export const handleChildUnchange = (selectedItems: string[], optionId: string, parentOption?: Option): string[] => {
  let newSelection = selectedItems.filter(id => id !== optionId);
  // If parent was selected, remove it
  if (parentOption && selectedItems.includes(parentOption.id)) {
    const siblings = parentOption.children || [];
    const allSiblingsStillSelected = siblings.every(
      sibling => sibling.id !== optionId && newSelection.includes(sibling.id)
    );
    if (!allSiblingsStillSelected) {
      newSelection = newSelection.filter(id => id !== parentOption.id);
    }
  }
  return newSelection;
};

export const updateParentSelection = (selectedItems: string[], option: Option, checked: boolean): string[] => {
  const childrenIds = option.children?.map(child => child.id) || [];
  if (checked) {
    const newSelection = [...selectedItems, option.id, ...childrenIds];
    return [...new Set(newSelection)];
  } else {
    return selectedItems.filter(id => id !== option.id && !childrenIds.includes(id));
  }
};

export const toggleExpandedSet = (expanded: Set<string>, optionId: string): Set<string> => {
  const newSet = new Set(expanded);
  if (newSet.has(optionId)) {
    newSet.delete(optionId);
  } else {
    newSet.add(optionId);
  }
  return newSet;
};
